<template>
  <div class="uk-container uk-margin-small-top">
    <h2 class="uk-heading-small uk-text-center">Create a New Project</h2>
    <p class="uk-text-center">Enter some basic info to get started.</p>
    <form class="uk-form-stacked uk-width-1-2@s uk-align-center">
      <div class="uk-margin">
        <label class="uk-form-label" for="fName">First Name</label>
        <div class="uk-form-controls">
          <input
            id="fName"
            v-model="tempBasicInfo.fName"
            class="uk-input"
            type="text"
          />
        </div>
      </div>

      <div class="uk-margin">
        <label class="uk-form-label" for="lName">Last Name</label>
        <div class="uk-form-controls">
          <input
            id="lName"
            v-model="tempBasicInfo.lName"
            class="uk-input"
            type="text"
          />
        </div>
      </div>

      <div class="uk-margin">
        <label class="uk-form-label" for="email">Email</label>
        <div class="uk-form-controls">
          <input
            id="email"
            v-model="tempBasicInfo.email"
            class="uk-input"
            type="text"
          />
        </div>
      </div>

      <div class="uk-margin">
        <label class="uk-form-label" for="email">Phone</label>
        <div class="uk-form-controls">
          <input
            id="phone"
            v-model="tempBasicInfo.phone"
            class="uk-input"
            type="text"
          />
        </div>
      </div>

      <div class="uk-margin">
        <label class="uk-form-label" for="company">Company</label>
        <div class="uk-form-controls">
          <input
            id="company"
            v-model="tempBasicInfo.company"
            class="uk-input"
            type="text"
          />
        </div>
      </div>

      <div class="uk-margin">
        <label class="uk-form-label" for="client">Client</label>
        <div class="uk-form-controls">
          <input
            id="client"
            v-model="tempBasicInfo.client"
            class="uk-input"
            type="text"
          />
        </div>
      </div>

      <div class="uk-margin">
        <div class="uk-form-label">
          Select the Products You're Interested In
        </div>
        <div class="uk-form-controls">
          <div
            uk-grid="margin: uk-grid-margin-small"
            class="uk-margin uk-grid-medium uk-child-width-1-2@m uk-grid"
          >
            <div>
              <label>
                <input
                  v-model="tempBasicInfo.productInterest.ties"
                  class="uk-checkbox"
                  type="checkbox"
                />
                Ties
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    Available in 3 widths and 3 lengths. Polyester twill fabric
                    made from recycled plastic bottles to look and feel like
                    silk.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <label>
                <input
                  v-model="tempBasicInfo.productInterest.bowTies"
                  class="uk-checkbox"
                  type="checkbox"
                />
                Bow Ties
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    Self-tie, butterfly style. Polyester twill fabric made from
                    recycled plastic bottles to look and feel like silk.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <label>
                <input
                  v-model="tempBasicInfo.productInterest.pocketSquares"
                  class="uk-checkbox"
                  type="checkbox"
                />
                Pocket Squares
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    12" x 12", single-sided print. Polyester twill fabric made
                    from recycled plastic bottles to look and feel like silk.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <label>
                <input
                  v-model="tempBasicInfo.productInterest.infinityScarves"
                  class="uk-checkbox"
                  type="checkbox"
                />
                Infinity Scarves
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    Super-soft, light weight. Approximately 56" x 8", sewn into
                    a continuous loop. Made with fine silk-like poly crepe de
                    chine.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <label>
                <input
                  v-model="tempBasicInfo.productInterest.chiffonScarves"
                  class="uk-checkbox"
                  type="checkbox"
                />
                Chiffon Scarves
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    Light weight. Available in two styles: 72" x 24" or 28" x
                    28", sewn with finely finished edges. Made with fine
                    silk-like poly chiffon.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <label>
                <input
                  v-model="tempBasicInfo.productInterest.neckGaiters"
                  class="uk-checkbox"
                  type="checkbox"
                />
                Neck Gaiters
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    Available in two sizes and lightweight or insulated styles.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-margin">
        <div class="uk-form-label">In-Hand Deadline</div>
        <div class="uk-form-controls">
          <flat-pickr
            id="deadline"
            v-model="tempBasicInfo.deadline"
            :config="flatPickrConfig"
            class="uk-input"
            type="text"
          ></flat-pickr>
        </div>
      </div>
    </form>
    <div class="uk-width-1-2@s uk-align-center">
      <div class="uk-margin uk-align-right">
        <button
          v-if="isComplete"
          class="uk-button uk-button-primary"
          @click="setBasicInfo()"
        >
          Continue
        </button>
        <button v-if="!isComplete" disabled class="uk-button uk-button-primary">
          Complete All fields to continue
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import CrmService from "@/services/CrmService";
import LogRocket from "logrocket";

export default {
  name: "CreateDistProject",
  components: {
    flatPickr
  },
  data() {
    return {
      tempBasicInfo: {
        fName: null,
        lName: null,
        email: null,
        phone: null,
        company: null,
        client: null,
        productInterest: {
          ties: false,
          bowTies: false,
          pocketSquares: false,
          infinityScarves: false,
          chiffonScarves: false,
          neckGaiters: false
        },
        deadline: null,
        adSource: null,
        segment: "distributor",
        saved: false
      },
      flatPickrConfig: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: "M	j, Y",
        altInput: true,
        dateFormat: "Y-m-d"
      }
    };
  },
  computed: {
    basicInfo() {
      return this.$store.state.newDistProject.basicInfo;
    },
    isComplete() {
      if (
        this.tempBasicInfo.fName &&
        this.tempBasicInfo.lName &&
        this.hasProduct &&
        this.emailIsValid
      ) {
        return true;
      }
    },
    hasProduct() {
      for (
        var i = 0;
        i < Object.values(this.tempBasicInfo.productInterest).length;
        i++
      ) {
        if (Object.values(this.tempBasicInfo.productInterest)[i]) {
          return true;
        }
      }
    },
    emailIsValid() {
      if (
        this.tempBasicInfo.email &&
        this.tempBasicInfo.email.includes("@") &&
        this.tempBasicInfo.email.includes(".")
      ) {
        return true;
      }
    }
  },
  mounted: function() {
    if (this.basicInfo.saved) {
      this.tempBasicInfo = JSON.parse(JSON.stringify(this.basicInfo));
    }
    if (this.$route.query.adSource) {
      const adSource = this.$route.query.adSource;
      this.tempBasicInfo.adSource = adSource;
    }
  },
  methods: {
    setBasicInfo() {
      CrmService.partialInquiry(this.tempBasicInfo);
      LogRocket.identify(this.tempBasicInfo.email);
      setTimeout(() => {
        this.$store.commit("newDistProject/setBasicInfo", this.tempBasicInfo);
        this.$router.push({ name: "SelectDistStyles" });
      }, 500);
    }
  }
};
</script>

<style type="text/css">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/distributor-onboarding/CreateDistProject.vue